<template>
  <div class="add-serving-size">
    <h4 class="add-serving-size__title">{{ $t('label.add_new_serving_size') }}</h4>
    <el-form
       label-position="top"
      :ref="formRef"
      :model="formData"
      :rules="rules">


      <el-form-item
         prop="title"
        :label="$t('label.title')">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>


      <el-form-item
        :label="$t('label.weight')">
        <el-input-number
          v-model="formData.weight_gr"
          class="w-50"
          prop="weight_gr">
        </el-input-number>
        <span class="unit">{{ $t('label.in_grams') }}</span>
      </el-form-item>

      <el-form-item
         prop="description"
        :label="$t('label.description')">
        <el-input v-model="formData.description"></el-input>
      </el-form-item>

      <div class="submit-section">
        <el-button type="primary" size="small" @click="submitForm">{{ $t('label.add_new') }}</el-button>
        <el-button size="small" type="text" @click="cancel" class="add-serving-size__cancel">{{ $t('label.cancel') }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'cmpt-add-serving-size',
  mixins: [
    FormStandardBehavior,
  ],
  data() {
    return {
      formData: {
        amount: 1,
        title: null,
        description: null,
        weight_gr: null,
      },
      rules: {
        title: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.title', true),
          },
        ],
        weight_gr: [
          {
            required: true,
            type: 'number',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.weight', true),
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return this.removeEmpty(this.formData);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
  created() {
    this.formRef = 'form-add-serving-size';
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .add-serving-size {
    margin: 0 -1em 1em;

    .add-serving-size__title {
      margin: 0;
      padding: 0.25em 1em;
      font-weight: 500;
    }

    .el-form {
      position: relative;
      padding: 1em;
      border-top: 1px solid $nutrition-facts-orange-light-border;
      border-bottom: 1px solid $nutrition-facts-orange-light-border;
      background-color: $nutrition-facts-orange-light-bg;
      &:before {
        display: inline-block;
        content: '';
        width: 0.75em;
        height: 0.75em;
        position: absolute;
        top: -0.4em; right: 1.5em;
        background-color: $nutrition-facts-orange-light-bg;
        border-left: 1px solid $nutrition-facts-orange-light-border;
        border-top: 1px solid $nutrition-facts-orange-light-border;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }

    /deep/ .el-form-item {
      .el-form-item__label {
        line-height: 1;
      }
    }

    .unit {
      margin-left: 0.5em;
    }
    .submit-section {
      margin-left: 0;
      .add-serving-size__cancel {
        float: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/serving-sizes/cmpt-add-serving-size.vue